import {
  DESKTOP_BREAKPOINT,
  TAB_BREAKPOINT,
} from "../constants/homePageCategory";

export const isDesktop = () => {
  const windowInnerWidth = window.innerWidth;
  return windowInnerWidth >= DESKTOP_BREAKPOINT;
};

export const isTablet = () => {
  const windowInnerWidth = window.innerWidth;
  return (
    windowInnerWidth < DESKTOP_BREAKPOINT &&
    windowInnerWidth > TAB_BREAKPOINT
  );
};
